import { createActions, createReducer } from 'reduxsauce'

import ConsultaLicitacaoCovidService from '../../servicos/ConsultaLicitacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaLicitacaoCovidInicio: [],
    buscaConsultaLicitacaoCovidErro: ['erro'],
    buscaConsultaLicitacaoCovidSucesso: ['consultaLicitacaoCovid'],
    limpar: [],
    setConsultaLicitacaoCovidEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaLicitacaoCovid = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaLicitacaoCovidInicio())
        let serv = new ConsultaLicitacaoCovidService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaLicitacaoCovidSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaLicitacaoCovidErro(error)))
    }
}

const buscaConsultaLicitacaoCovidInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaLicitacaoCovidErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaLicitacaoCovidSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaLicitacaoCovid.resultado,
        dataSincronizacaoDados: action.consultaLicitacaoCovid.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaLicitacaoCovidEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_LICITACAO_COVID_INICIO]: buscaConsultaLicitacaoCovidInicio,
    [Types.BUSCA_CONSULTA_LICITACAO_COVID_ERRO]: buscaConsultaLicitacaoCovidErro,
    [Types.BUSCA_CONSULTA_LICITACAO_COVID_SUCESSO]: buscaConsultaLicitacaoCovidSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_LICITACAO_COVID_ESTADO_DT]: setConsultaLicitacaoCovidEstadoDT,
})
